// src/app/shared/components/header/header.component.ts
import { Component, OnInit, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { BreakpointObserver, Breakpoints, LayoutModule } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// PrimeNG Imports
import { MenubarModule } from 'primeng/menubar';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
// import { MenuModule } from 'primeng/menu'; // <-- ELIMINAR O COMENTAR ESTA LÍNEA
import { Menu as PrimeNgMenuComponent } from 'primeng/menu'; // <-- MANTENER ESTA IMPORTACIÓN (el alias es clave)

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    LayoutModule,
    // PrimeNG Modules
    MenubarModule,
    ButtonModule,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export default class HeaderComponent implements OnInit, OnDestroy {
  isMobileView: boolean = false;
  isTabletView: boolean = false;
  isDesktopView: boolean = false;

  menus: Menu[] = [
    {
      path: '/',
      label: 'Inicio',
      showOnMobile: false,
      showOnTablet: false,
      showOnDesktop: true,
    },
    {
      path: '/about',
      label: 'Sobre nosotros',
      showOnMobile: false,
      showOnTablet: false,
      showOnDesktop: true,
    },
    {
      label: 'Servicios',
      showOnMobile: false,
      showOnTablet: false,
      showOnDesktop: true,
      child: [
        {
          path: '/services/individual',
          label: 'Individuos',
          showOnMobile: true,
          showOnTablet: true,
          showOnDesktop: true,
        },
        {
          path: '/services/companies',
          label: 'Empresas',
          showOnMobile: true,
          showOnTablet: true,
          showOnDesktop: true,
        },
      ],
    },
    {
      path: '/contact',
      label: 'Contacto',
      showOnMobile: false,
      showOnTablet: false,
      showOnDesktop: true,
    },
  ];

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private breakpointObserver: BreakpointObserver) {}

  ngOnInit() {
    this.breakpointObserver.observe([
      Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape
    ]).pipe(takeUntil(this.destroy$)).subscribe(result => this.isMobileView = result.matches);

    this.breakpointObserver.observe([
      Breakpoints.TabletPortrait, Breakpoints.TabletLandscape
    ]).pipe(takeUntil(this.destroy$)).subscribe(result => this.isTabletView = result.matches);

    this.breakpointObserver.observe([
      Breakpoints.WebPortrait, Breakpoints.WebLandscape
    ]).pipe(takeUntil(this.destroy$)).subscribe(result => this.isDesktopView = result.matches);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  trackByFn(index: number, item: any): number {
    return index;
  }

  convertChildToMenuItems(children: Menu[]): MenuItem[] {
    return children.map(child => ({
      label: child.label,
      routerLink: child.path,
    }));
  }

  toggleMenu(event: Event, menu: PrimeNgMenuComponent) {
    menu.toggle(event);
  }
}

export interface Menu {
  path?: string;
  label: string;
  menu?: string;
  child?: Menu[];
  hash?: string;
  showOnMobile?: boolean;
  showOnTablet?: boolean;
  showOnDesktop?: boolean;
}